import { LocaleString } from '@/components/types'
import { DateTimeRange } from '@/composables/useTimeRange'

export const dateSelectionTypes = [
  'now',
  'last24h',
  'yesterday',
  'last7d',
  'last30d',
  'lastquarter',
  'last12m',
  'currentyear',
  'lastyear',
  'last5years',
  'custom'
] as const

export type DateSelectionType = typeof dateSelectionTypes[number]

export type DateSelection = {
  name: string
  title: LocaleString
  range?: DateTimeRange
  access: string[]
  icon?: LocaleString
  largeIcon?: LocaleString
}
